// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"378":"site","975":"site-blog"}[chunkId] || chunkId) + "." + {"144":"9810c992","324":"de188ff1","378":"1160c8af","437":"86add91e","453":"bd1d3d4e","568":"1984613f","687":"efaddd4c","787":"1b933f5d","948":"8a28932c","975":"fc0be751"}[chunkId] + ".chunk.js";
};